/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An MCP registry
 */
export type MCPRegistry = {
  /**
   * Registry ID
   */
  id: string;
  /**
   * Display name for the registry
   */
  name: string;
  /**
   * URL of the registry
   */
  url: string;
};

/** @internal */
export const MCPRegistry$inboundSchema: z.ZodMiniType<MCPRegistry, unknown> = z
  .object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
  });

export function mcpRegistryFromJSON(
  jsonString: string,
): SafeParseResult<MCPRegistry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MCPRegistry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MCPRegistry' from JSON`,
  );
}
